import type { FC } from "react";
import Accordion from "./components/Accordion/Accordion";

const Faq: FC = () => {
  const faqItems = [
    {
      question: "Могу ли я редактировать приглашение после публикации?",
      answer:
        "К сожалению, самостоятельное редактирование приглашения после публикации невозможно, но вы можете связаться с нами в telegram, указав ссылку на ваше приглашение и необходимые изменения. Мы бесплатно внесем их в ваше приглашение",
    },
    {
      question: "Как я буду получать ответы гостей?",
      answer:
        "К сожалению, самостоятельное редактирование приглашения после публикации невозможно, но вы можете связаться с нами в telegram, указав ссылку на ваше приглашение и необходимые изменения. Мы бесплатно внесем их в ваше приглашение",
    },
    {
      question: "На каких девайсах доступен просмотр приглашения?",
      answer:
        "К сожалению, самостоятельное редактирование приглашения после публикации невозможно, но вы можете связаться с нами в telegram, указав ссылку на ваше приглашение и необходимые изменения. Мы бесплатно внесем их в ваше приглашение",
    },
    {
      question: "Что делать, если возникли технические проблемы?",
      answer:
        "К сожалению, самостоятельное редактирование приглашения после публикации невозможно, но вы можете связаться с нами в telegram, указав ссылку на ваше приглашение и необходимые изменения. Мы бесплатно внесем их в ваше приглашение",
    },
    {
      question: "Какую информацию гость увидит на сайте когда получит ссылку?",
      answer:
        "К сожалению, самостоятельное редактирование приглашения после публикации невозможно, но вы можете связаться с нами в telegram, указав ссылку на ваше приглашение и необходимые изменения. Мы бесплатно внесем их в ваше приглашение",
    },
    {
      question: "Как долго будет доступен мой сайт-приглашение?",
      answer:
        "К сожалению, самостоятельное редактирование приглашения после публикации невозможно, но вы можете связаться с нами в telegram, указав ссылку на ваше приглашение и необходимые изменения. Мы бесплатно внесем их в ваше приглашение",
    },
  ];
  return (
    <section
      className={
        "max-w-[328px] sm:flex sm:max-w-[1220px] sm:flex-row sm:gap-[80px] md:gap-[133px]"
      }
    >
      <div>
        <h2
          className={
            "mb-4 font-primary-condensed text-600 font-bold uppercase leading-[1.2] tracking-[-0.03em] text-primary sm:text-900 md:text-950"
          }
        >
          Мы заботимся о вашем комфорте и спокойствии
        </h2>
        <p
          className={
            "mb-8 text-300 font-normal leading-[1.2] text-primary sm:leading-[1.4] md:text-400"
          }
        >
          поэтому заранее ответили на все интересующие вас вопросы
        </p>
      </div>
      <Accordion items={faqItems} />
    </section>
  );
};

export default Faq;
